import { EditOutlined, UserAddOutlined,PlusOutlined } from "@ant-design/icons";
import { Button, Tag, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../app/hooks";
import { UserContactCreationForm } from "../../Drawers/UserContactCreationForm";
import * as Styles from './ManageContactStyles'
import { API_URL } from "../../../API/Config";
import ReTable from "../../../unity-ui-common/Components/ReTable/ReTable";
import { user } from "../../../API/UserManagement/User";
import { convertDateInReadableFormat } from "../../../Helper/Methods";
import ImportUserContactListModal from "../../UserContactList/ImportUserContactListModal";
import { loadState } from "../../../sessionstorage";
import { auth } from "../../../API/Auth";
import { tenant as tenantAPI } from "../../../API/UserManagement/Tenant";
import { Link } from "react-router-dom";
import { Filter } from "../../../Routes/SitesReport/SitesReportStyles";
import { text } from "stream/consumers";
import { ReNotification } from "../../../unity-ui-common/Components/ReNotification";

function ManageContact() {
  const [selectedTableRow, setSelectedTableRow] = useState<string[]>([]);
  const [currEditingUser, setCurrEditingUser] = useState({});
  const [userDrawerVisibility, setUserDrawerVisibility] =
    useState<boolean>(false);
    const [isFileUploded, setIsFileUploded] = useState(false);
    const [isImported, setIsImported] = useState(false);
  const [userDrawerType, setUserDrawerType] = useState<string>("");
  const [importModal, setImportModal] = useState(false);
  const [userData,setUserData] = useState({})
  const [refreshTable,setRefreshTable] =useState(false);
  const [commonRefresh,setCommonRefresh] = useState<boolean>(false)
  
  const selectedTenant = useAppSelector((state) => state.session.selectedTenant);
  const dataEntryMode = (selectedTenant as any)?.configs?.dataEntryMode || "Hybrid";
  const handleEditUser = async (data: any) => {  
    const userData = await user.getUser(data.user_id);
    setUserData(userData)
    setCurrEditingUser(data);
    setUserDrawerType("view");
    setUserDrawerVisibility(true);
  };
const tentant = JSON.parse(sessionStorage.getItem('selectedTenant') || '{}')?.id;

  const columns = [
    // {
    //   title: "Contact Id",
    //   dataIndex: "id",
    //   key:"id",
    //   width: 200,
    //   render: (record: any,data:any) => {
    //     return (
    //       <>
           
    //           <Tooltip title="view">
    //               <Link
    //              to=""
    //            onClick={() => {
    //             handleEditUser(data);
    //         }}
    //             style={{cursor:"pointer",color:""}}
    //              >
    //             {record}
    //             </Link>
               
    //             {/* <EditOutlined
    //               style={{ cursor: "pointer" }}
    //               onClick={() => {
    //                 handleEditUser(record.id);
    //               }}
    //             /> */}
    //           </Tooltip>
           
    //       </>
    //     );
    //   },
    // },
    {
      title: "Contact Name",
      dataIndex: "name",
      key:"name",
      width: 250,
      render: (record: any,data:any) => {
        return (
          <>
           
              <Tooltip title="view">
                  <Link
                 to=""
               onClick={() => {
                handleEditUser(data);
            }}
                style={{cursor:"pointer",color:""}}
                 >
                {record}
                </Link>
               
                {/* <EditOutlined
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleEditUser(record.id);
                  }}
                /> */}
              </Tooltip>
           
          </>
        );
      },
    },
    {
      title: "Role",
      dataIndex: "rol_mat",
      key:"rol_mat",
      // render: (role_matrices: any) => {
      //   // Filter roles based on the current tenant
      //   const tenantId = tentant; // Use the tenant variable
      //   const userData = loadState()?.session?.userData;
      //   const tenant = userData?.tenants?.find((t: any) => t.id === tenantId);
      //   const tenantName = tenant ? tenant.name : "Unknown Tenant";
      //   const filteredRoles = role_matrices?.filter((mt: any) => mt.tenant === tenantName);
      //   // Fallback if tenant not found

      //   return (
      //     <div>
      //       {filteredRoles?.map((mt: any) => {
      //         return <p style={{margin: 0}}>{`${mt?.roles.join(", ")}`}</p>;
      //       })}
      //     </div>
      //   );
      // },
      width: 250,
      render: (value: any) => (value ? value : "-"),
    },
    {
      title: "Contact Country",
      dataIndex: "country",
      key:"country",
    //   render: (record: any) => {
    //     const text = record === 1 ? "Active" : "Inactive";
    //     const color = record === 1 ? "green" : "red";
    //     return (
    //       <Tag color={color} title="status">
    //         {text}
    //       </Tag>
    //     );
    //   },
    width: 250,
    render: (value: any) => (value ? value : "-"),
    },
    {
      title: "Mode of Correspondence",
      dataIndex: "mode_of_correspondence",
      key:"mode_of_correspondence",
      width: 250,
      // render: (value: any, record: any) => {
        
      //   return "Email";
      // },
    },
    {
      title: "Status",
      dataIndex: "status",
      key:"status",
        render: (value: any) => {
        const isActive =
          value === 1 ||
          value === "1" ||
          value === true ||
          value === "true" ||
          (typeof value === "string" && value.toLowerCase() === "active");
        const text = isActive ? "Active" : "Inactive";
        const color = isActive ? "green" : "red";
        return (
          <Tag color={color} title="status">
            {text}
          </Tag>
        );
      },
      // filters : [
      //   {text: "Active", value: 1},
      //   {text: "Inactive", value: 0}
      // ],

      width: 250,
    },
    {
        title: "Site Number",
        dataIndex: "site_number",
        key:"site_number",
        width: 250,
        render: (value: any) => (value ? value : "-"),
    },
    {
      title: "Site Name",
      dataIndex: "site_name",
      key:"site_name",
      width: 250,
      render: (value: any) => (value ? value : "-"),
  },
      {
        title: "Study Number",
        dataIndex: "study_number",
        key:"study_number",
        width: 250,
        render: (value: any) => (value ? value : "-"),
      },
      {
        title: "Last Modified Date",
        dataIndex: "updated_at",
        key:"updated_at",
        width: 250,
        render: (value: any, record: any) => {
          const text = record.updated_at
            ? `${convertDateInReadableFormat(record.updated_at)}`
            : "-";
          return text;
        },
        
      },
    // {
    //   title: "Sponsor/MAH with roles",
    //   dataIndex: "roleMatrices",
    //   render: (roleMatrices: any) => {
    //     return (
    //       <div>
    //         {roleMatrices?.map((mt: any) => {
    //           return <p style={{margin: 0}}>{`${mt?.tenant}: ${mt?.roles.join(", ")}`}</p>;
    //         })}
    //       </div>
    //     );
    //   },
    // },
  ];
  useEffect(()=>{
    setRefreshTable(commonRefresh)
    },[commonRefresh])
  return (
    <Styles.Container>
      <UserContactCreationForm
        drawerType={userDrawerType}
        visibility={userDrawerVisibility}
        setUserDrawerType={setUserDrawerType}
        setUserDrawerVisibility={setUserDrawerVisibility}
        currEditingUser={currEditingUser}
        userData={userData}
        setCommonRefresh={setCommonRefresh}
      />
      <ReTable
        name="All Users"
        title="All Users"
        columns={columns}
        columnOptions={{
            sorting: {
              columns: [
                "id",
                "name",
                "rol_mat",
                "country",
                "status",
                "site_number",
                "site_name",
                "study_number",
                "updated_at",
                "mode_of_correspondence"
              ],
              sortingDirections: ["ascend", "descend"],
            },
            filter: {
              filterSearch: true,
              columns: [
                "id",
                "name",
                // "role_matrices",
                "rol_mat",
                // {
                //   key: "role_matrices",
                //   action: (role_matrices: any) => {
                //     // Assuming role_matrices is an array of objects with tenant and roles
                   
                //     const userData = loadState()?.session?.userData;
                //     const tenantId = tentant; // Use the tenant variable
                
                //     // Find the tenant name based on tenantId
                //     const tenant = userData?.tenants?.find((t: any) => t.id === tenantId);
                //     const tenantName = tenant ? tenant.name : "Unknown Tenant"; // Fallback if tenant not found
                
                //     // Filter roles based on the current tenant
                //     const filteredRoles = role_matrices?.filter((mt: any) => mt.tenant === tenantName);
                
                //     // Return formatted roles or a fallback message
                //     return filteredRoles?.length > 0 
                //       ? `${filteredRoles.map((mt: any) => mt.roles.join(", ")).join(", ")}`
                //       : "-";
                //   },
                   
                // },
                "country",
                // "status",
                {
                  key: "status",
                  items: [
                   
                    {
                      text: "Inactive",
                      value: "0" 
                    },
                    {
                      text: "Active",
                      value: "1" 
                    },
                  ]
                },
                "site_number",
                "site_name",
                "study_number",
                "mode_of_correspondence",
                {
                  key: "updated_at",
                  action: (date: any) =>
                    date ? convertDateInReadableFormat(date) : "-",
                }
              ],
            },
          }}
        refresh={refreshTable}
        scroll={{
          x: 800,
          y: 500,
        }}
        selectAllOnlyCurrentPage={true}
        rowSelection={{
          selectedRowKeys: selectedTableRow,
          type: "checkbox",
          setSelectedRowKeys: setSelectedTableRow,
          rowKey: "id",
        }}
        uniView={{
          uniView: "user",
          viewName: "allUsers",
          apiUrl: API_URL,
          option: {
            orderBy: {
              key: "updated_at",
              order: "DESC",
            },
            limit: 10,
          },
        }}
        exportOption={{
          csv: {},
        }}
        headerButtons={[
          {
            title: "Import",
            icon: <PlusOutlined />,
            onClick: () => {
              setImportModal(!importModal);
            },
            visibility: true,
          },
          {
            title: "Add New",
            icon: <UserAddOutlined />,
            onClick: () => {
              setUserDrawerType("create");
              setUserDrawerVisibility(true);
            },
            visibility: true,
          },
          
        ]}
      />
      <ImportUserContactListModal
          visibility={importModal}
          setVisibility={setImportModal}
          isImported={isImported}
          setIsImported={setIsImported}
          setIsFileUploded={setIsFileUploded}
          isFileUploded={isFileUploded}
          setCommonRefresh={setCommonRefresh}
          // getTableData={getTableData}
          
          
        />
    </Styles.Container>
  );
}

export default ManageContact;
